export default __webpack_public_path__ + "static/media/laboratory.15fe1282.png";